"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.some.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vue2Editor = require("vue2-editor");
var _log = require("@/utils/log");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cookie = require("@/utils/cookie");
var _resource = require("@/api/resource");
var _user = require("@/api/user");
var _utils = require("@/utils");
var _index = _interopRequireDefault(require("../../../../components/EventTime/index.vue"));
var _subscriptions = require("@/api/subscriptions");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const tmpLoopGeninfo = {};
var _default = exports.default = {
  name: 'LoopGeninfo',
  components: {
    VueEditor: _vue2Editor.VueEditor,
    EventTime: _index.default
  },
  props: {
    parentLoop: {
      type: Object,
      default: tmpLoopGeninfo
    },
    displayType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogResourceVisible: false,
      dialogContactVisible: false,
      tableLoading: false,
      loopType: _lifehikesInitData.loopType,
      resourceQuery: {
        page: 1,
        limit: 999,
        q: undefined,
        type: undefined,
        sort: 'title'
      },
      contactQuery: {
        page: 1,
        limit: 999,
        q: undefined,
        sort: '-updatedAt'
      },
      resourceOptions: [],
      userList: [],
      customToolbar: [['bold'], [{
        list: 'bullet'
      }]],
      loading: false,
      timeZoneList: _lifehikesInitData.ianaTimeZone,
      countryList: [],
      tagInputVisible: false /* use for Tag component */,
      tagInputValue: '' /* use for tag component */,
      loop: {},
      loggedInUserTenants: [],
      subscriptionsList: [],
      subscriptionsLoading: false
    };
  },
  watch: {
    loop: {
      handler(newVal) {
        this.passBackGenInfo(newVal);
      },
      deep: true
    }
  },
  created() {
    this.loop = this.parentLoop;
    this.fetchLoopSubscriptions();
    console.info('loop info');
    console.info(this.loop);
    // console.info(JSON.stringify(this.parentLoop));
    this.$store.dispatch('facets/getInitData', 'en').then(() => {
      this.countryList = this.$store.getters.countries;
    });
    if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
      this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
    }
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    openSubscription(id) {
      window.open(`/#/subscriptions/edit/${id}`, '_blank');
    },
    fetchLoopSubscriptions() {
      this.subscriptionsList = [];
      if (this.loop.metadata && this.loop.metadata.subscriptionId) {
        const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
        if (!token) return;
        this.subscriptionsLoading = true;
        const subId = this.loop.metadata.subscriptionId;
        (0, _subscriptions.getSubscriptionById)(token, subId).then(response => {
          if (response.data && response.data.title) {
            if (!this.subscriptionsList.some(s => s.id === subId)) {
              this.subscriptionsList.push({
                id: subId,
                title: response.data.title
              });
            }
          }
        }).catch(error => {
          (0, _log.showDebugLog)('LoopGeninfo-getSubscriptionById-error', error);
          if (!this.subscriptionsList.some(s => s.id === subId)) {
            this.subscriptionsList.push({
              id: subId,
              title: 'Subscription: ' + subId
            });
          }
        }).finally(() => {
          this.subscriptionsLoading = false;
        });
      }
    },
    prefillFeedbackLink() {
      this.loop.feedbackUrl = `https://otr.link/${this.loop.internal.opportunityNumber}`;
    },
    passBackGenInfo(myLoop) {
      console.info(myLoop);
      this.$emit('updateParentGenInfo', myLoop);
    },
    openResourceDialog(type) {
      this.dialogResourceVisible = true;
      this.resourceQuery.type = type;
      this.getResources();
    },
    getResources() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _resource.fetchList)(token, this.resourceQuery).then(response => {
        const data = response.data;
        this.resourceOptions = data.rows;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-API-response', error);
        this.tableLoading = false;
        displayPopupMessage(error, 'error');
      });
    },
    addResourceInStage(id, title) {
      this.loop.welcomeBox.resource = id;
      this.loop.welcomeBox.resourceTitle = title;
      this.dialogResourceVisible = false;
    },
    clearReplayResource() {
      this.loop.welcomeBox.resource = '';
      this.loop.welcomeBox.resourceTitle = '';
      this.$forceUpdate();
    },
    openContactDialog() {
      this.dialogContactVisible = true;
      this.getList();
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _user.getUserList)(token, this.contactQuery).then(response => {
        const data = response.data;
        this.userList = data.rows;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('GetUserList-api-error', error);
        this.tableLoading = false;
        displayPopupMessage(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    addContactInStage(userinfo) {
      this.loop.welcomeBox.coachUuid = userinfo.id;
      this.loop.welcomeBox.coachUgivenName = userinfo.givenName + ' ' + userinfo.familyName;
      this.dialogContactVisible = false;
    },
    clearContactResource() {
      this.loop.welcomeBox.coachUuid = null;
      this.loop.welcomeBox.coachUgivenName = '';
      this.$forceUpdate();
    },
    showUTCDate(utcDate) {
      // 'YYYY-MM-DD HH:mm:ss [GMT]Z[ (]z[)]'
      // 'YYYY-MM-DD HH:mm:ss (zZ)'
      return (0, _momentTimezone.default)(utcDate).utc().format('YYYY-MM-DD HH:mm:ss (z+0)');
    }
  }
};